<template>
  <section :class="contentClasses">
    <div class="row">
      <div class="col-12">
        <search-scope-select-bar v-if="useCombinedSearch" :config="searchFiltersConfig" />
      </div>
    </div>
    <search-filters
      :config="searchFiltersConfig"
    />
    <datasets-info-box />
    <selectedFacetsOverview
      :defaultFacetOrder="['content_type', 'country']"
      :selected-facets="getFacets"
      :available-facets="getSearchFacets"
    />
    <dataset-details-skeleton v-if="getLoading" type="Datasets" />
    <template v-if="!getLoading">
      <dataset-list-infos />
      <editorial-content-list />
    </template>
  </section>
</template>

<script>
import {
  DatasetDetailsSkeleton,
  SelectedFacetsOverview,
} from "@piveau/piveau-hub-ui-modules";
import SearchFilters from "@/components/search/search-filters/SearchFilters";
import DatasetListInfos from "@/components/search/datasets/DatasetListInfos";
import DatasetsInfoBox from "@/components/search/datasets/DatasetsInfoBox";
import {mapGetters} from "vuex";
import SearchScopeSelectBar from "@/components/search/search-filters/SearchScopeSelectBar";
import EditorialContentList from "@/components/search/editorial-content/EditorialContentList";

export default {
  name: "EditorialContentContent",
  components: {
    EditorialContentList,
    SearchScopeSelectBar,
    SearchFilters,
    DatasetDetailsSkeleton,
    SelectedFacetsOverview,
    DatasetListInfos,
    DatasetsInfoBox,
    
  },
  data() {
    return {
      searchFiltersConfig: {
        scope: "editorialContent",
        apiFilter: 'filters=resource',
        apiQueryParams: 'resource=editorial-content',
          textFieldHelpLink: `https://dataeuropa.gitlab.io/data-provider-manual/how-to-search/search-for-datasets/`,
        textKeys: {
          mobileSearchButton: 'message.datasets.ecd.filters.search',
          textFieldPlaceholder: 'message.search.searchBarPlaceholder.editorialcontent',
          count: "message.search.countMessage.editorialcontent",
          loading: "Loading editorial content..."
        },
        getQuery: ["datasets", "getQuery"],
        setQuery: ["datasets", "setQuery"],
        setSort: ["datasets", "setSort"],
        getCount: ["search", "getEditorialContentCount"],
        getLoading: ["datasets", "getLoading"],
        getFacets: ["datasets", "getFacets"],
      },
      useCombinedSearch: this.$env.content.useCombinedSearch
    }
  },
  computed: {
    ...mapGetters("datasets", ["getQuery", "getAllAvailableFacets", "getFacets",
      "getLoading", "getDatasetsCount"]),
    ...mapGetters("search", ["getSearchFacets", "getShowFilter"]),
      contentClasses() {
      // Full width when facets are hidden or not in use
      if (!this.getShowFilter) {
        return 'col-12 px-lg-0 px-sm-2'; 
      }
      // Default classes when facets are shown
      return 'col-md-9 col-12';
    }
  }
}
</script>
